import { buildAppUrl, buildLogoutUrl, getConfig, getPublicOrigin } from "@/config";

const State = {
  UserName: '',
  Profile: null
};

const getters = {
  isAuthenticated: (state) => !!state.Profile,
  StateUserName: (state) => state.UserName,
  StateProfile: (state) => state.Profile,
  StateToken: () => '',
  StateRefreshToken: () => '',
  StateExpiresAt: () => ''
};

const actions = {

  saveAPIauth({ commit }, data) {
    commit('auth_success', data);
  },

  refreshToken() {
    // Token refresh handled by oauth2-proxy
  },

  logout({ commit, state }) {

    // 1️⃣ Capture idTokenHint BEFORE clearing state
    let idTokenHint = state.Profile?.idTokenHint || "";
    // Remove "Bearer " prefix if present
    if (idTokenHint.startsWith("Bearer ")) {
      idTokenHint = idTokenHint.substring(7);
    }

    // 2️⃣ Clear Vue state + browser storage
    commit("logout_success");
    localStorage.clear();
    sessionStorage.clear();

    // 3️⃣ Build URLs
    const keycloakLogout = getConfig("OAUTH.KEYCLOAK_LOGOUT");
    const clientId = getConfig("OAUTH.CLIENT_ID");
    const finalDestination = buildAppUrl("/");
    const proxyLogoutBase = new URL(buildLogoutUrl(), getPublicOrigin()).toString();

    // oauth2-proxy clears its cookie, then sends user to finalDestination
    const proxySignOutUrl =
      proxyLogoutBase +
      "?rd=" + encodeURIComponent(finalDestination);

    // Keycloak logout → then hit proxy sign_out
    let keycloakLogoutUrl =
      keycloakLogout +
      "?client_id=" + encodeURIComponent(clientId) +
      "&post_logout_redirect_uri=" + encodeURIComponent(proxySignOutUrl) +
      "&id_token_hint=" + encodeURIComponent(idTokenHint); // ✅ always present now

    if (getConfig("ENABLE_DEBUG")) {
      console.log("idTokenHint present:", !!idTokenHint);
      console.log("Captured idTokenHint for logout:", idTokenHint);
      console.log("keycloak logout URL:", keycloakLogoutUrl);
    }

    // 4️⃣ Trigger logout — Keycloak will honor post_logout_redirect_uri
    //    because id_token_hint is present
    window.location.href = keycloakLogoutUrl;
  },

  revokeToken({ commit }) {
    commit('logout_success');
  }

};

const mutations = {

  auth_success(state, data) {
    if(getConfig("ENABLE_DEBUG")) {
      console.log("Auth success, data received:", data);
    }
    if (data?.UserName) {
      state.UserName = data.UserName;
    }
    state.Profile = data || null;
  },

  logout_success(state) {
    state.UserName = '';
    state.Profile = null;
  }

};

export default { state: State, getters, actions, mutations };
// ```

// ---

// ### What changed vs your original code

// | | Before | After |
// |---|---|---|
// | `idTokenHint` captured | After `commit("logout_success")` → always empty | Before commit → has the value |
// | `id_token_hint` in URL | Only added `if (idTokenHint)` → was never added | Always included |
// | `client_id` encoding | Not encoded | `encodeURIComponent` added |

// ---

// ### Why this now works
// ```
// Keycloak receives:
//   ?client_id=xxx
//   &post_logout_redirect_uri=.../oauth2/sign_out?rd=...
//   &id_token_hint=eyJ...   ← Keycloak 18+ REQUIRES this
//           ↓
// Keycloak clears SSO session ✅
//           ↓
// Redirects to /oauth2/sign_out  ← proxy clears its cookie ✅
//           ↓
// Redirects to /  ← user lands back on your site ✅